// @ts-nocheck
// Estudo 2.0 — EstudoScreen2: wrapper stateful que liga o redesign à API real.
// Self-contained: faz as próprias mutações via apiV2 (react, vote, comment, create, qbox).
import React, { useState, useEffect, useMemo, useCallback } from 'react';
import { api } from '../../../services/apiV2';
import { isLicao } from './ui2';
import { StudyContext } from './cards2';
import { EstudoFeed } from './feed2';
import { ComposeSheet2 } from './composer2';
import {
  ReadingSheet, CommentsSheet, MenuSheet, EditSheet, AskAnonymousSheet,
  QboxAdminSheet, InsightDetailScreen, ThemeView,
} from './sheets2';
import { IcoFlame, IcoTrophy, IcoLock, IcoCrown, IcoCheck, IcoTrash, IcoFlag, IcoBulb } from './icons2';

function Toast({ msg, icon }: any) {
  const Icon = { flame: IcoFlame, trophy: IcoTrophy, lock: IcoLock, crown: IcoCrown, check: IcoCheck, trash: IcoTrash, flag: IcoFlag, bulb: IcoBulb }[icon] || IcoCheck;
  return (
    <div style={{ position: 'fixed', left: '50%', bottom: 'calc(96px + var(--sab,0px))', transform: 'translateX(-50%)', zIndex: 100, maxWidth: 420, width: 'calc(100% - 40px)', display: 'flex', justifyContent: 'center', pointerEvents: 'none' }}>
      <div style={{ display: 'inline-flex', alignItems: 'center', gap: 9, padding: '12px 18px', borderRadius: 999, background: 'var(--paper-3)', border: '1px solid var(--line-strong)', color: 'var(--ink)', fontSize: 14, fontWeight: 600, boxShadow: '0 12px 40px rgba(0,0,0,0.4)', animation: 'e2PopIn 0.3s cubic-bezier(0.2,0.8,0.2,1) both' }}>
        <Icon size={17} style={{ color: 'var(--ember)' }} />{msg}
      </div>
    </div>
  );
}

export function EstudoScreen2(props: any) {
  const {
    session, clubId, clubName, clubBook, isAdmin, canPost = false, viewerId, viewerIsModerator,
    milestones = [], posts = [], loading, yourPage = 0, filter, onChangeFilter,
    onBack, onRefetch, onReloadMilestones, headerExtra, storiesTray, onCommentAdded,
    initialMilestoneId, onAfterInitialMilestone,
  } = props;
  const isElevated = !!isAdmin;

  const [localPosts, setLocalPosts] = useState(posts);
  useEffect(() => { setLocalPosts(posts); }, [posts]);

  const [selectedMilestone, setSelectedMilestone] = useState<any>(null);
  const [visibleCount, setVisibleCount] = useState(8);
  const [search, setSearch] = useState('');
  const [toast, setToast] = useState<any>(null);

  // sheets
  const [compose, setCompose] = useState<any>({ open: false, kind: 'escrever' });
  const [reading, setReading] = useState<any>(null);
  const [comments, setComments] = useState<any>(null);
  const [menu, setMenu] = useState<any>(null);
  const [edit, setEdit] = useState<any>(null);
  const [ask, setAsk] = useState<any>(null);
  const [qboxAdmin, setQboxAdmin] = useState<any>(null);
  const [insight, setInsight] = useState<any>(null);
  const [theme, setTheme] = useState<any>(null);

  // caches
  const [commentsCache, setCommentsCache] = useState<any>({});
  const [commentsLoading, setCommentsLoading] = useState(false);
  const [qboxQs, setQboxQs] = useState<any>([]);
  const [qboxLoading, setQboxLoading] = useState(false);

  const active = milestones.find((m: any) => m.state === 'active');
  const flash = useCallback((msg: string, icon?: string) => { setToast({ msg, icon }); setTimeout(() => setToast(null), 2600); }, []);

  useEffect(() => { setVisibleCount(8); }, [filter, selectedMilestone]);

  // Abre a página de Estudos SEM teclado: o iOS mantém o teclado aberto ao navegar
  // (foco herdado de um input da tela anterior, ex. busca do hub) e nada AQUI deve
  // receber foco no mount. Então dismissamos qualquer foco ativo ao montar.
  useEffect(() => {
    const blur = () => { const el: any = document.activeElement; if (el && (el.tagName === 'INPUT' || el.tagName === 'TEXTAREA' || el.isContentEditable)) el.blur(); };
    blur();
    const r = requestAnimationFrame(blur);
    return () => cancelAnimationFrame(r);
  }, []);

  // deep-link de marco (ex: "ver feed deste marco" no Insight Final). Seleciona o marco
  // pedido — só se ele existir na lista — e limpa o sinal pra não reabrir ao navegar.
  useEffect(() => {
    if (!initialMilestoneId) return;
    if (milestones.some((m: any) => m.id === initialMilestoneId)) setSelectedMilestone(initialMilestoneId);
    onAfterInitialMilestone && onAfterInitialMilestone();
  }, [initialMilestoneId]); // eslint-disable-line

  /* ---------- lista exibida (search + milestone client-side; filtro tab é server-side) ---------- */
  const displayed = useMemo(() => {
    const q = (search || '').trim().toLowerCase();
    if (q) {
      const terms = q.split(/\s+/).filter(Boolean);
      const SYN: any = { reflection: 'reflexão estudo pensamento', citation: 'citação trecho', question: 'pergunta', quiz: 'quiz', 'question-box': 'caixa de perguntas dúvidas', 'leader-answer': 'resposta líder', 'insight-final': 'insight final marco' };
      return localPosts.filter((p: any) => {
        const type = isLicao(p) ? 'lição ensino aula estudo' : (SYN[p.kind] || '');
        const hay = [p.text, p.comment, p.prompt, p.title, p.question, p.author?.name, type, (p.tags || []).join(' ')].filter(Boolean).join(' ').toLowerCase();
        return terms.every((t) => hay.includes(t));
      });
    }
    let arr = localPosts;
    if (selectedMilestone) arr = arr.filter((p: any) => p.milestoneId === selectedMilestone);
    return arr;
  }, [localPosts, selectedMilestone, search]);

  const searching = (search || '').trim().length > 0;
  const shown = searching ? displayed : displayed.slice(0, visibleCount);
  const hasMore = !searching && visibleCount < displayed.length;

  /* ---------- themes (Fios — só funciona quando posts têm tags) ---------- */
  const themes = useMemo(() => {
    const map: any = {};
    localPosts.forEach((p: any) => (p.tags || []).forEach((t: string) => { map[t] = (map[t] || 0) + 1; }));
    return Object.entries(map).sort((a: any, b: any) => b[1] - a[1]).map(([tag, count]) => ({ tag, count }));
  }, [localPosts]);

  /* ---------- reactions ---------- */
  const onReact = useCallback((postId: string, kind: string) => {
    if (!canPost) { flash('Entre no grupo para reagir', 'lock'); return; }
    setLocalPosts((ps: any) => ps.map((p: any) => {
      if (p.id !== postId) return p;
      const has = (p.yourReactions || []).includes(kind);
      return {
        ...p,
        yourReactions: has ? p.yourReactions.filter((k: string) => k !== kind) : [...(p.yourReactions || []), kind],
        reactions: { ...p.reactions, [kind]: Math.max(0, (p.reactions?.[kind] || 0) + (has ? -1 : 1)) },
      };
    }));
    api.reactToPost(session, clubId, postId, kind).catch((e: any) => { console.error('[e2:react]', e?.message); flash('Não foi possível reagir', 'flag'); });
  }, [session, clubId, canPost, flash]);

  /* ---------- quiz vote ---------- */
  const onVote = useCallback(async (postId: string, qid: string, oid: string) => {
    if (!canPost) { flash('Entre no grupo para votar', 'lock'); return; }
    try {
      const r = await api.voteQuiz(session, clubId, postId, qid, oid);
      setLocalPosts((ps: any) => ps.map((p: any) => {
        if (p.id !== postId) return p;
        const questions = (p.questions || []).map((q: any) => q.id === qid ? { ...q, options: r.options, totalVotes: r.totalVotes } : q);
        return { ...p, questions, yourAnswers: { ...(p.yourAnswers || {}), [qid]: r.yourVote } };
      }));
    } catch (e: any) { console.error('[e2:vote]', e?.message); flash('Não foi possível votar', 'flag'); }
  }, [session, clubId, canPost, flash]);

  /* ---------- comentários ---------- */
  const loadComments = useCallback(async (postId: string) => {
    setCommentsLoading(true);
    try {
      const r = await api.listComments(session, clubId, postId);
      setCommentsCache((c: any) => ({ ...c, [postId]: r.comments || [] }));
    } catch (e: any) { console.error('[e2:comments]', e?.message); flash('Erro ao carregar discussão', 'flag'); }
    finally { setCommentsLoading(false); }
  }, [session, clubId, flash]);

  const addComment = useCallback(async (postId: string, text: string, parentId?: string) => {
    if (!canPost) { flash('Entre no grupo para comentar', 'lock'); return; }
    try {
      await api.createComment(session, clubId, postId, text, parentId || undefined);
      await loadComments(postId);
      setLocalPosts((ps: any) => ps.map((p: any) => p.id === postId ? { ...p, comments: (p.comments || 0) + 1 } : p));
      onCommentAdded && onCommentAdded(postId, 1);
    } catch (e: any) { flash(e?.message || 'Erro ao comentar', 'flag'); }
  }, [session, clubId, loadComments, onCommentAdded, flash]);

  const editComment = useCallback(async (postId: string, cid: string, text: string) => {
    try { await api.updateComment(session, clubId, postId, cid, text); await loadComments(postId); }
    catch (e: any) { flash(e?.message || 'Erro ao editar', 'flag'); }
  }, [session, clubId, loadComments, flash]);

  const deleteComment = useCallback(async (postId: string, cid: string) => {
    try {
      await api.deleteComment(session, clubId, postId, cid);
      await loadComments(postId);
      setLocalPosts((ps: any) => ps.map((p: any) => p.id === postId ? { ...p, comments: Math.max(0, (p.comments || 0) - 1) } : p));
      onCommentAdded && onCommentAdded(postId, -1);
    } catch (e: any) { flash(e?.message || 'Erro ao excluir', 'flag'); }
  }, [session, clubId, loadComments, onCommentAdded, flash]);

  const reactComment = useCallback(async (postId: string, cid: string, kind: string) => {
    if (!canPost) { flash('Entre no grupo para reagir', 'lock'); return; }
    setCommentsCache((cache: any) => {
      const list = cache[postId]; if (!list) return cache;
      return { ...cache, [postId]: list.map((c: any) => {
        if (c.id !== cid) return c;
        const has = (c.yourReactions || []).includes(kind);
        return { ...c, yourReactions: has ? c.yourReactions.filter((k: string) => k !== kind) : [...(c.yourReactions || []), kind], reactions: { ...(c.reactions || {}), [kind]: Math.max(0, ((c.reactions || {})[kind] || 0) + (has ? -1 : 1)) } };
      }) };
    });
    try { await api.reactToComment(session, clubId, postId, cid, kind as any); }
    catch (e: any) { console.error("[e2:reactComment]", e?.message); flash('Não foi possível reagir', 'flag'); }
  }, [session, clubId, canPost, flash]);

  /* ---------- criar post ---------- */
  const onCreate = useCallback(async (payload: any) => {
    if (!canPost) { flash('Entre no grupo para publicar', 'lock'); return; }
    try {
      await api.createPost(session, clubId, {
        kind: payload.kind, content: payload.content,
        page: payload.page || undefined, milestoneId: active ? active.id : undefined,
      });
      setCompose({ open: false, kind: 'escrever' });
      if (payload.kind === 'insight-final') { flash('Marco encerrado com seu insight 🔥', 'trophy'); onReloadMilestones && onReloadMilestones(); }
      else if (payload.kind === 'reflection' && (payload.content.text || '').startsWith('§ensino§')) flash('Lição publicada — ensine o grupo 💡', 'bulb');
      else { const labels: any = { reflection: 'Estudo publicado', citation: 'Citação ancorada', question: 'Pergunta no ar', quiz: 'Quiz publicado', 'question-box': 'Caixa de perguntas aberta' }; flash(labels[payload.kind] || 'Publicado', 'flame'); }
      onRefetch && onRefetch();
    } catch (e: any) { flash(e?.message || 'Erro ao publicar', 'flag'); throw e; }
  }, [session, clubId, active, canPost, flash, onRefetch, onReloadMilestones]);

  /* ---------- qbox ---------- */
  const submitAsk = useCallback(async (post: any, text: string) => {
    if (!canPost) { flash('Entre no grupo para perguntar', 'lock'); return; }
    try {
      await api.askQuestionBox(session, clubId, post.id, text);
      setAsk(null);
      setLocalPosts((ps: any) => ps.map((p: any) => p.id === post.id ? { ...p, questionsReceived: (p.questionsReceived || 0) + 1 } : p));
      flash('Pergunta enviada anonimamente 🔒', 'lock');
    } catch (e: any) { flash(e?.message || 'Erro ao enviar', 'flag'); }
  }, [session, clubId, canPost, flash]);

  const openQboxAdmin = useCallback(async (post: any) => {
    setQboxAdmin(post); setQboxLoading(true); setQboxQs([]);
    try { const r = await api.listQuestionBoxQuestions(session, clubId, post.id); setQboxQs(r.questions || []); }
    catch (e: any) { console.error('[e2:qbox]', e?.message); flash('Erro ao carregar perguntas', 'flag'); }
    finally { setQboxLoading(false); }
  }, [session, clubId, flash]);

  const answerQbox = useCallback(async (post: any, question: any, text: string) => {
    try {
      await api.answerQuestionBoxQuestion(session, clubId, post.id, question.id, text);
      setQboxQs((qs: any) => qs.map((x: any) => x.id === question.id ? { ...x, state: 'answered' } : x));
      flash('Resposta do líder publicada', 'crown');
      onRefetch && onRefetch();
    } catch (e: any) { flash(e?.message || 'Erro ao responder', 'flag'); }
  }, [session, clubId, flash, onRefetch]);

  /* ---------- editar / excluir / denunciar ---------- */
  const onSaveEdit = useCallback(async (post: any, content: any) => {
    try {
      await api.updatePost(session, clubId, post.id, content);
      setLocalPosts((ps: any) => ps.map((p: any) => p.id === post.id ? { ...p, ...content } : p));
      setEdit(null); flash('Alterações salvas', 'check');
    } catch (e: any) { flash(e?.message || 'Erro ao salvar', 'flag'); }
  }, [session, clubId, flash]);

  const onDelete = useCallback(async (post: any) => {
    try {
      await api.deletePost(session, clubId, post.id);
      setLocalPosts((ps: any) => ps.filter((p: any) => p.id !== post.id));
      setReading(null); setComments(null); setInsight(null);
      flash('Post excluído', 'trash');
    } catch (e: any) { flash(e?.message || 'Erro ao excluir', 'flag'); }
  }, [session, clubId, flash]);

  const onReport = useCallback(async (post: any) => {
    try { await api.reportPost(session, post.id, 'inapropriado'); flash('Denúncia enviada. Obrigado.', 'flag'); }
    catch (e: any) { flash(e?.message || 'Erro ao denunciar', 'flag'); }
  }, [session, flash]);

  /* ---------- abrir discussão (reflexão profunda → leitura; resto → sheet) ---------- */
  const openComments = useCallback((post: any) => {
    if (!commentsCache[post.id]) loadComments(post.id);
    if (post.kind === 'reflection' && /^##\s/m.test(post.text || '')) setReading(post);
    else setComments(post);
  }, [commentsCache, loadComments]);

  const openReading = useCallback((post: any) => {
    if (!commentsCache[post.id]) loadComments(post.id);
    setReading(post);
  }, [commentsCache, loadComments]);

  const openInsight = useCallback((post: any) => {
    if (!commentsCache[post.id]) loadComments(post.id);
    setInsight(post);
  }, [commentsCache, loadComments]);

  const canManage = useCallback((post: any) => post.author?.id === viewerId || viewerIsModerator, [viewerId, viewerIsModerator]);
  const milestoneOf = (post: any) => milestones.find((m: any) => m.id === post.milestoneId);

  const ctx = useMemo(() => ({
    isElevated, clubBook, canPost,
    onReact, onVote,
    onOpenProfile: props.onOpenProfile,
    onOpenComments: openComments,
    onOpenReading: openReading,
    onOpenInsight: openInsight,
    onOpenTheme: (tag: string) => setTheme(tag),
    onMenu: (post: any) => setMenu(post),
    onAskQbox: (post: any) => setAsk(post),
    onManageQbox: (post: any) => openQboxAdmin(post),
  }), [isElevated, clubBook, canPost, onReact, onVote, openComments, openReading, openInsight, openQboxAdmin]);

  const curPost = (p: any) => (p ? localPosts.find((x: any) => x.id === p.id) || p : p);

  return (
    <StudyContext.Provider value={ctx}>
      <EstudoFeed
        posts={shown} milestones={milestones} clubName={clubName} clubBook={clubBook}
        filter={filter} setFilter={onChangeFilter}
        selectedMilestone={selectedMilestone} setSelectedMilestone={setSelectedMilestone}
        currentPage={yourPage} themes={themes} visibleCount={visibleCount}
        onLoadMore={() => setVisibleCount((v) => v + 8)} hasMore={hasMore}
        onCompose={() => setCompose({ open: true, kind: 'escrever' })}
        onOpenTheme={(t: string) => setTheme(t)} search={search} setSearch={setSearch}
        canPost={canPost}
        onBack={onBack} headerExtra={headerExtra} storiesTray={storiesTray} loading={loading}
      />

      <ComposeSheet2 open={compose.open} initialKind={compose.kind} onClose={() => setCompose({ open: false, kind: 'escrever' })}
        onCreate={onCreate} isElevated={isElevated} activeMilestone={active} />

      {reading && <ReadingSheet post={curPost(reading)} comments={commentsCache[reading.id]} commentsLoading={commentsLoading && !commentsCache[reading.id]}
        viewerId={viewerId} onClose={() => setReading(null)} onReact={onReact} onMenu={setMenu}
        onAddComment={addComment} onEditComment={editComment} onDeleteComment={deleteComment} onReactComment={reactComment} />}

      {comments && <CommentsSheet post={curPost(comments)} comments={commentsCache[comments.id]} commentsLoading={commentsLoading && !commentsCache[comments.id]}
        viewerId={viewerId} clubBook={clubBook} onClose={() => setComments(null)} onReact={onReact}
        onAddComment={addComment} onEditComment={editComment} onDeleteComment={deleteComment} onReactComment={reactComment} />}

      {menu && <MenuSheet post={menu} onClose={() => setMenu(null)} canManage={canManage(menu)}
        onEdit={setEdit} onDelete={onDelete} onReport={onReport} />}

      {edit && <EditSheet post={edit} onClose={() => setEdit(null)} onSave={onSaveEdit} />}

      {ask && <AskAnonymousSheet post={ask} onClose={() => setAsk(null)} onSubmit={submitAsk} />}

      {qboxAdmin && <QboxAdminSheet post={qboxAdmin} questions={qboxQs} loading={qboxLoading} onClose={() => setQboxAdmin(null)} onAnswer={answerQbox} />}

      {insight && <InsightDetailScreen post={curPost(insight)} comments={commentsCache[insight.id]} commentsLoading={commentsLoading && !commentsCache[insight.id]}
        milestone={milestoneOf(insight)} viewerId={viewerId} onClose={() => setInsight(null)} onReact={onReact}
        onAddComment={addComment} onEditComment={editComment} onDeleteComment={deleteComment} onReactComment={reactComment}
        onOpenMilestoneFeed={(m: any) => { setInsight(null); setSelectedMilestone(m.id); }} />}

      {theme && <ThemeView tag={theme} posts={localPosts} onClose={() => setTheme(null)} />}

      {toast && <Toast msg={toast.msg} icon={toast.icon} />}
    </StudyContext.Provider>
  );
}
